import React from "react";
import { Link } from "react-router-dom";
import { Fish } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-white/10 py-14 bg-ink-bg">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="grid place-items-center w-9 h-9 rounded-full border border-cyan-brand/40 text-cyan-brand">
                <Fish size={18} strokeWidth={1.8} />
              </span>
              <span className="font-display font-extrabold tracking-tight text-lg text-white">SOR<span className="text-cyan-brand">.</span></span>
            </div>
            <p className="mt-4 text-white/50 max-w-xs">{t.footer.tagline}</p>
          </div>
          <div className="flex gap-16">
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40 mb-4">{t.footer.product}</p>
              <ul className="space-y-2 text-sm text-white/60">
                <li>gestionale.sor.de</li>
                <li>team.sor.de</li>
                <li>pac.sor.de</li>
              </ul>
            </div>
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40 mb-4">{t.footer.company}</p>
              <ul className="space-y-2 text-sm text-white/60">
                <li><Link to="/admin" className="hover:text-cyan-brand transition-colors duration-200" data-testid="footer-admin-link">{t.nav.admin}</Link></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-2 font-mono text-[11px] text-white/35">
          <span>© {year} SOR. {t.footer.rights}</span>
          <span>www.sor.de</span>
        </div>
      </div>
    </footer>
  );
}
